export default __webpack_public_path__ + "static/media/cart-black.c5c0240c.svg";